import { Fragment } from 'react';
import { UsageCard } from './UsageCard';
import { Entity } from '@backstage/catalog-model';

export const RelationshipsCard = ({
  usedBy,
  using,
}: {
  usedBy: Entity[];
  using: Entity[];
}) => {
  let usedByGrid = null;
  let usingGrid = null;
  if (usedBy?.length > 0) {
    usedByGrid = <UsageCard entities={usedBy} title="Used By" />;
  }

  if (using?.length > 0) {
    usingGrid = <UsageCard entities={using} title="Using" />;
  }

  return (
    <Fragment>
      {usedByGrid}
      {usingGrid}
    </Fragment>
  );
};
